import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { login } from '../../../api';
import { setAuthData } from '../../../utils/auth';
import { GoPerson } from "react-icons/go";
import { CiLock } from "react-icons/ci";

function LoginPC() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    nickname: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Clear form fields when component mounts (after logout)
  useEffect(() => {
    setFormData({
      nickname: '',
      password: ''
    });
    setError('');
    
    // Force clear any browser auto-fill
    const inputs = document.querySelectorAll('input[type="text"], input[type="password"]');
    inputs.forEach(input => {
      input.value = '';
    });
  }, []);

  // Helper function to handle redirect after login
  const handleRedirectAfterLogin = () => {
    const redirectUrl = localStorage.getItem('redirectAfterLogin');
    
    if (redirectUrl) {
      localStorage.removeItem('redirectAfterLogin');
      navigate(redirectUrl);
    } else {
      navigate('/');
    }
  };

  // Set authentication status for memorial plaza pages
  const setMemorialPlazaAuthentication = () => {
    localStorage.setItem('isAuthenticated', 'true');
    localStorage.setItem('authenticationTimestamp', Date.now().toString());
    
    // Also ensure the main login state is set
    localStorage.setItem('isLoggedIn', 'true');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    
    if (!formData.nickname || !formData.password) {
      alert('아이디와 비밀번호를 입력하세요.');
      setLoading(false);
      return;
    }

    try {
      const response = await login(formData.nickname, formData.password);
      const resp = response?.data || response;
      const token =
        resp?.token ||
        resp?.accessToken ||
        resp?.data?.token ||
        resp?.data?.accessToken;
      // Extract userId from response
      const userId = resp?.userId || resp?.data?.userId;
      const role = resp?.role || resp?.data?.role || "";  // ✅ define role
      
      // Create user object with available data
      const user = {
        nickname: formData.nickname,
        userId: userId,
        role: role
      };

      if (!token) {
        throw new Error('로그인에 실패했습니다. 다시 시도해 주세요.');
      }

      // Store authentication token and user info
      setAuthData(token, user,role);
      // setAuthData(token, user);
      
      // Set authentication status for memorial plaza pages
      setMemorialPlazaAuthentication();
      
      // Clear form fields after successful login
      setFormData({ nickname: '', password: '' });
      
      // Add a small delay to ensure localStorage is updated before navigation
      setTimeout(() => {
        handleRedirectAfterLogin();
      }, 100);
    } catch (err) {
      alert('아이디/비밀번호가 잘못되었습니다.');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <div style={{
      width: '100%',
      minHeight: '100vh',
      fontFamily: "'Inter', sans-serif",
      margin: 0,
      padding: 0,
      boxSizing: 'border-box'
    }}>
      

      {/* Login Section */}
      <main className="loginpc-login-section" style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '80px 20px',
        backgroundImage: 'url("/images/7de3678c23f3e744cb9051f5ad0445783afaf55b.png")',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        position: 'relative',
        minHeight: '100vh',
        width: '100%'
      }}>
        {/* Dark overlay */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.4)',
          zIndex: 0
        }}></div>
        <div className="loginpc-login-container" style={{
          position: 'relative',
          zIndex: 1,
          textAlign: 'center',
          width: '100%',
          maxWidth: '500px',
          margin: '7% auto'
        }}>
          <p className="loginpc-welcome-text" style={{
            color: '#ffffff',
            fontSize: '24px',
            fontWeight: '600',
            letterSpacing: '1px',
            margin: '0 0 20px 0',
            // color: '#fff', 
            // textShadow: '2px 2px 4px rgba(0, 0, 0, 0.6)'
          }}>WELCOME TO KANGHWA PARADISE</p>
          <div className="loginpc-login-box" style={{
            backgroundColor: '#ffffff',
            borderRadius: '15px',
            boxShadow: '0 10px 30px rgba(0,0,0,0.3)',
            padding: '50px 40px',
            position: 'relative',
            backdropFilter: 'blur(10px)', 
            width: '100%'
          }}>
            <div style={{
              content: '',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              height: '4px',
              background: 'linear-gradient(90deg, #2fb5a8 0%, #1a8a7f 100%)'            
            }}></div>
            <h1 className="loginpc-title" style={{
              fontSize: '36px',
              fontWeight: '600',
              color: '#000000',
              margin: '0 0 40px 0',
              letterSpacing: '-0.5px'
            }}>로그인</h1>
            <form onSubmit={handleSubmit} autoComplete="off" style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '25px',
              width: '100%'
            }}>
              <div style={{
                display:'flex',
                flexDirection:'row' 
              }}>
                <div style={{
                  position: 'absolute',
                  left: '50px',
                  top: '34%',
                  transform: 'translateY(-50%)',
                  width: '20px',
                  height: '20px',
                }}>
                <span style={{ color: '#999',
                  fontSize: '20px'}}><GoPerson />        
                </span> 
                </div>  
               
                <input 
                  type="text" 
                  name="nickname"
                  placeholder="아이디" 
                  className="loginpc-input" 
                  value={formData.nickname}
                  onChange={handleChange}
                  disabled={loading}
                  autoComplete="off"
                  style={{
                    width: '100%',
                    border: '2px solid #e0e0e0',
                    borderRadius: '8px',
                    padding: '15px 15px 15px 45px',
                    fontSize: '16px',
                    color: '#222222',
                    backgroundColor: '#f8f8f8',
                    transition: 'all 0.3s ease'
                  }} 
                />
              </div>
              <div style={{
                position: 'relative',
                width: '100%'
              }}>
                 <div style={{
                  position: 'absolute',
                  left: '12px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  width: '20px',
                  height: '20px',
                }}>
                <span style={{ color: '#999',
                  fontSize: '20px'}}><CiLock />        
                </span> 
                </div>  
                <input 
                  type="password" 
                  name="password"
                  placeholder="비밀번호" 
                  className="loginpc-input" 
                  value={formData.password}
                  onChange={handleChange}
                  disabled={loading}
                  autoComplete="off"
                  style={{
                    width: '100%',
                    border: '2px solid #e0e0e0',
                    borderRadius: '8px',
                    padding: '15px 15px 15px 45px',
                    fontSize: '16px',
                    color: '#222222',
                    backgroundColor: '#f8f8f8',
                    transition: 'all 0.3s ease'
                  }} 
                />
              </div>

              <button 
                type="submit" 
                className="loginpc-button" 
                disabled={loading}
                style={{
                  width: '100%',
                  backgroundColor: loading ? '#cccccc' : '#2fb5a8',
                  color: '#ffffff',
                  border: 'none',
                  borderRadius: '8px',
                  padding: '15px',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: loading ? 'not-allowed' : 'pointer',
                  transition: 'all 0.3s ease',
                  marginTop: '10px'
                }}
              >
                {loading ? '로그인 중...' : '로그인'}
              </button>
            </form>
            <div style={{
              marginTop: '30px',
              display: 'flex',
              flexDirection: 'column',
              gap: '15px'
            }}>
              <div className="loginpc-link-row" style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                fontSize: '14px'
              }}>
                <span className="loginpc-link-text" style={{ color: '#666666' }}>아이디, 비밀번호를 잊으셨나요?</span>
                <Link to="/find-account" className="loginpc-link-text" style={{
                  color: '#2fb5a8',
                  textDecoration: 'none',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '5px',
                  fontWeight: '500'
                }}>
                  아이디/비밀번호 찾기 &gt;
                </Link>
              </div>
              <div className="loginpc-link-row" style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                fontSize: '14px'
              }}>
                <span className="loginpc-link-text" style={{ color: '#666666' }}>아직 파라다이스 추모원 회원이 아니신가요?</span>
                <Link to="/signup" className="loginpc-link-text" style={{
                  color: '#2fb5a8',
                  textDecoration: 'none',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '5px',
                  fontWeight: '500'
                }}>
                  회원가입 &gt;
                </Link>
              </div>
            </div>
          </div>
        </div>
      </main>

    </div>
  );
}

export default LoginPC; 